import React from 'react';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import getDisplayName from 'utils/getDisplayName';

import {
  getDiningOptions,
  getDiningOptionDetail,
  createDiningOption,
  deleteDiningOption,
  editDiningOption,
  setIsEnabledDiningOption,
  setIsDefaultDiningOption,
} from './actions';
import {
  selectDiningOptions,
  selectDiningOptionsFetching,
  selectDiningOptionsFetched,
  selectDiningOptionsError,
  selectCreateDiningOption,
  selectCreateDiningOptionFetching,
  selectCreateDiningOptionFetched,
  selectCreateDiningOptionError,
  selectDeleteDiningOptionFetching,
  selectDeleteDiningOptionFetched,
  selectDeleteDiningOptionError,
  selectEditDiningOption,
  selectEditDiningOptionFetching,
  selectEditDiningOptionFetched,
  selectEditDiningOptionError,
  selectSetIsEnabledDiningOptionFetching,
  selectSetIsEnabledDiningOptionFetched,
  selectSetIsEnabledDiningOptionError,
  selectDiningOptionDetail,
  selectDiningOptionDetailFetching,
  selectDiningOptionDetailFetched,
  selectDiningOptionDetailError,
  selectSetIsDefaultDiningOptionFetching,
  selectSetIsDefaultDiningOptionFetched,
  selectSetIsDefaultDiningOptionError,
} from './selectors';

export function withDiningOptionsHoc(Component) {
  function withDiningOptions(props) {
    return <Component {...props} />;
  }

  withDiningOptions.displayName = `withDiningOptions(${getDisplayName(Component)})`;

  return withDiningOptions;
}

const mapStateToProps = createStructuredSelector({
  diningOptionsList: selectDiningOptions,
  diningOptionsFetching: selectDiningOptionsFetching,
  diningOptionsFetched: selectDiningOptionsFetched,
  diningOptionsError: selectDiningOptionsError,
  createDiningOptionObject: selectCreateDiningOption,
  createDiningOptionFetching: selectCreateDiningOptionFetching,
  createDiningOptionFetched: selectCreateDiningOptionFetched,
  createDiningOptionError: selectCreateDiningOptionError,
  deleteDiningOptionFetching: selectDeleteDiningOptionFetching,
  deleteDiningOptionFetched: selectDeleteDiningOptionFetched,
  deleteDiningOptionError: selectDeleteDiningOptionError,
  editDiningOptionObject: selectEditDiningOption,
  editDiningOptionFetching: selectEditDiningOptionFetching,
  editDiningOptionFetched: selectEditDiningOptionFetched,
  editDiningOptionError: selectEditDiningOptionError,
  setIsEnabledDiningOptionFetching: selectSetIsEnabledDiningOptionFetching,
  setIsEnabledDiningOptionFetched: selectSetIsEnabledDiningOptionFetched,
  setIsEnabledDiningOptionError: selectSetIsEnabledDiningOptionError,
  diningOptionDetailObject: selectDiningOptionDetail,
  diningOptionDetailFetching: selectDiningOptionDetailFetching,
  diningOptionDetailFetched: selectDiningOptionDetailFetched,
  diningOptionDetailError: selectDiningOptionDetailError,
  setIsDefaultDiningOptionFetching: selectSetIsDefaultDiningOptionFetching,
  setIsDefaultDiningOptionFetched: selectSetIsDefaultDiningOptionFetched,
  setIsDefaultDiningOptionError: selectSetIsDefaultDiningOptionError,
});

export function mapDispatchToProps(dispatch) {
  return {
    loadDiningOptions: (storeUuid) => dispatch(getDiningOptions(storeUuid)),
    loadDiningOptionDetail: ({ storeUuid, diningOptionUuid }) =>
      dispatch(getDiningOptionDetail({ storeUuid, diningOptionUuid })),
    createDiningOption: ({ storeUuid, diningOption }) => dispatch(createDiningOption({ storeUuid, diningOption })),
    deleteDiningOption: ({ storeUuid, diningOptionUuid }) =>
      dispatch(deleteDiningOption({ storeUuid, diningOptionUuid })),
    editDiningOption: ({ storeUuid, diningOptionUuid, diningOption }) =>
      dispatch(editDiningOption({ storeUuid, diningOptionUuid, diningOption })),
    setIsEnabledDiningOption: ({ storeUuid, diningOptionUuid, isEnabled }) =>
      dispatch(setIsEnabledDiningOption({ storeUuid, diningOptionUuid, isEnabled })),
    setIsDefaultDiningOption: ({ storeUuid, diningOptionUuid, isDefault }) =>
      dispatch(setIsDefaultDiningOption({ storeUuid, diningOptionUuid, isDefault })),
    resetDiningOptions: () => dispatch(getDiningOptions.reset()),
    resetDiningOptionDetail: () => dispatch(getDiningOptionDetail.reset()),
    resetCreateDiningOption: () => dispatch(createDiningOption.reset()),
    resetDeleteDiningOption: () => dispatch(deleteDiningOption.reset()),
    resetEditDiningOption: () => dispatch(editDiningOption.reset()),
    resetSetIsEnabledDiningOption: () => dispatch(setIsEnabledDiningOption.reset()),
    resetSetIsDefaultDiningOption: () => dispatch(setIsDefaultDiningOption.reset()),
  };
}

export const withDiningOptionsState = connect(mapStateToProps, mapDispatchToProps);
export default compose(withDiningOptionsState, withDiningOptionsHoc);
